<template>
  <div id="app">
    <!-- <div id="nav">
       <router-link to="/">Home</router-link> |
       <router-link to="/about">About</router-link>
     </div>-->
    <router-view/>
    <loading v-show="loading" :text="loading"></loading>
  </div>
</template>


<script>
  import Loading from './components/Loading'
  export default {
    name: 'app',
    data () {
      return {}
    },
    computed: {
      loading() {
        return this.$store.state.loading;
      },
    },
    watch:{
      '$store.state.globalConfig':function () {
        document.title=this.$store.state.globalConfig.platform_name.value;
      }
    },
    components: { Loading },
    methods: {},
    created(){
    //获取全局配置
      this.$store.dispatch('setConfig');
    }
  }
</script>
<style lang="scss">
  @import "scss/app";
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  /*#nav {
    padding: 30px;
    a {
      font-weight: bold;
      color: #2c3e50;
      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }*/
</style>
